import React, { useContext, useState } from 'react'
import { useQuery, useMutation } from 'react-query';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import AuthContext from "../../../../../context/AuthProvider";
import {
	activeRegionalMembers,
	searchRegionalMember,
	findUserByEmail
} from "../../../../../api/apiServices";
import Pagination from '../../../../../services/Pagination';
import toast, { Toaster } from 'react-hot-toast'
// import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import jwt_decode from "jwt-decode";
import Loader from '../../../../Common/Spinner/Loader';


const titles = ['MR.', 'MR', 'MRS.', 'MISS'];

const ActiveRegionalMembers = () => {
	let [isLoading, setIsLoading] = useState(true);

	const { auth } = useContext(AuthContext)
	const decoded = auth?.accessToken
		? jwt_decode(auth.accessToken)
		: undefined

	const email = decoded?.UserInfo?.email || []

	const {
		data: userRegion,
	} = useQuery(['userRegion', email], () => findUserByEmail(email));

	let regional_code = userRegion?.region_code

	
	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/regional_members";

	const [search, setSearch] = useState(false);
	const [member, setMember] = useState([]);
	const [pf_number, setPFNumber] = useState(null);
	const [mobile_number, setMobileNumber] = useState(null);
	const [first_name, setFirstName] = useState(null);
	const [last_name, setLastName] = useState(null);

	const [currentPage, setCurrentPage] = useState(1);
	const [postPerPage, setPostPerPage] = useState(20);

	const {
		// isLoading,
		isError,
		error,
		data: actMembers,
	} = useQuery(['actMembers', regional_code], () => activeRegionalMembers(regional_code), {
		onSuccess: async () => {
			setIsLoading(false);
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
			setIsLoading(true);
			return false
		}
	});

	
	let total_membership = actMembers?.length


	const searchMutation = useMutation(searchRegionalMember, {
		onSuccess: async (res) => {
			setMember(res)
			setSearch(true)
		}
	})


	const handleSearch = async (e) => {
		e.preventDefault();

		const searchData = {
			regional_code: regional_code,
			pf_number: pf_number,
			mobile_number: mobile_number,
			first_name: first_name,
			last_name: last_name,
		}
		searchMutation.mutate(searchData)
	}

	const handleCancel = () => {
		setPFNumber("");
		setMobileNumber("");
		setFirstName("");
		setLastName("");
		setSearch(false);
		navigate(from, { replace: true });
	}

	let currentPosts = []
	const indexOfLastPage = currentPage * postPerPage;
	const indexOfFirstPage = indexOfLastPage - postPerPage;
	if (!search) {
		currentPosts = actMembers?.slice(indexOfFirstPage, indexOfLastPage);
	} else {
		currentPosts = member?.slice(indexOfFirstPage, indexOfLastPage);
	}

	let searchContent = (
		<form onSubmit={handleSearch} >
			<div className="form-group row">
				<div className="col-sm-2">
					<input
						className="form-control"
						type="text"
						style={{ textTransform: "uppercase" }}
						placeholder="PF Number"
						onChange={(e) => setPFNumber(e.target.value)}
						value={pf_number}
					/>
				</div>
				<div className="col-sm-2">
					<input
						className="form-control"
						type="text"
						// style={{ textTransform: "uppercase" }}
						placeholder="Mobile Number"
						onChange={(e) => setMobileNumber(e.target.value)}
						value={mobile_number}
					/>
				</div>
				<div className="col-sm-3">
					<input
						className="form-control"
						type="text"
						placeholder="FirstName"
						style={{ textTransform: "uppercase" }}
						onChange={(e) => setFirstName(e.target.value)}
						value={first_name}
					/>
				</div>
				<div className="col-sm-3">
					<input
						className="form-control"
						type="text"
						placeholder="LastName"
						style={{ textTransform: "uppercase" }}
						onChange={(e) => setLastName(e.target.value)}
						value={last_name}
					/>
				</div>
				<button
					type="submit"
					className="btn btn-success "
				> <i className="fa fa-search"></i> Search Application
				</button>
			</div>
		</form>
	)


	let content
	if (isLoading) {
		content = <div className="loader">
			<p>Loading Active Regional Members...</p>
			<Loader />
		</div>;
	}
	else if (isError) {
		content = <p>{error.message}</p>
	} else {
		content = 
			currentPosts && currentPosts?.length <= 0 ? (
				<div className="table-responsive lg">
					<table className="table table-bordered">
						<tbody>
							<tr>
								<td style={{ fontSize: "20px", fontWeight: "700", color: "#000", textAlign: "center" }}>
									There are no Active Members in the Region
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			) : (
			<div className='table-responsive lg'>
				<table className="table table-borderless table-hover table-striped">
					<thead className="align">
						<tr>
							<th scope="col">#</th>
							<th scope="col">PF Number</th>
							<th scope="col">Full Name</th>
							<th scope="col">Region</th>
							<th scope="col">Email</th>
							<th scope="col">Action</th>
						</tr>
					</thead>
					<tbody>
						{currentPosts.map((mem, index) =>
							<tr key={index}>
								<td>{postPerPage * (currentPage - 1) + index + 1}</td>
								<td>{mem.pf_number}</td>
								{titles.includes(mem.title) ?
									<td style={{ whiteSpace: 'nowrap' }}>{mem.first_name.toUpperCase()}&nbsp;{mem.middle_name.toUpperCase()}&nbsp;{mem.last_name.toUpperCase()}</td>
									:
									<td style={{ whiteSpace: 'nowrap' }}>{mem.title.toUpperCase()}&nbsp;{mem.first_name.toUpperCase()}&nbsp;{mem.middle_name.toUpperCase()}&nbsp;{mem.last_name.toUpperCase()}</td>
								}
								<td style={{ whiteSpace: 'nowrap' }}>{mem.region}</td>
								<td>{mem.email}</td>
								<td style={{ whiteSpace: 'nowrap' }}>
									<div style={{ display: 'inline-block' }}>
										<Link to={`/view_regional_member/${mem.id}`} className="small mr-3"> <i className='fa fa-eye'></i> view</Link>
									</div>&nbsp; &nbsp;
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		)
	}
	return (
		<><section className="content-header">
			<Toaster toastOptions={{ position: "top-center" }} />
			<h1>{userRegion?.region}: Total Active Members - {total_membership}</h1>
		</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											{searchContent}
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">
								{content}
							</div>
							<div className="panel-footer">
								{currentPosts && currentPosts?.length > 0 ? (
									<Pagination
										data={actMembers}
										postPerPage={postPerPage}
										currentPage={currentPage}
										setCurrentPage={setCurrentPage}
										setPostPerPage={setPostPerPage}
									/>
								) : (
									<div className="form-group row">
										<div className="col-sm-2">
											<button
												type="submit"
												className="btn btn-danger "
												onClick={handleCancel}
											> <i className="fa fa-search"></i> Cancel</button>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
					<div className="box-footer"></div>
				</div>
			</section>
		</>
	);
}

export default ActiveRegionalMembers;


